import { createSlice } from '@reduxjs/toolkit';
import { deleteEvent, getEvent, saveEvent } from 'services/actions/eventServiceAction';

interface EventState {
    loading: boolean;
    eventInfo: any; // Define the type of userInfo
    error: any; // Define the type of error
    success: boolean;
    loading1: boolean;
    success1: boolean;
    error1: any;
    saveEventInfo: any;
    loading2:boolean;
    error2:any;
    success2:boolean;
    delEventInfo:any;
}

const initialState: EventState = {
    loading: false,
    eventInfo: null,
    error: null,
    success: false,
    loading1: false,
    error1: null,
    success1: false,
    saveEventInfo: null,
    loading2:false,
    error2:null,
    success2:false,
    delEventInfo:null,
}

const eventSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getEvent.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
                state.eventInfo=null;
            })
            .addCase(getEvent.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.eventInfo = payload;
                state.success = true;
            })
            .addCase(getEvent.rejected, (state, { payload }) => {
                state.loading = false;
                state.error = payload;
                state.success = false;
            })
            .addCase(saveEvent.pending, (state) => {
                state.loading1 = true;
                state.error1 = null;
                state.success1 = false;
                state.saveEventInfo=null;
            })
            .addCase(saveEvent.fulfilled, (state, { payload }) => {
                state.loading1 = false;
                state.saveEventInfo = payload;
                state.success1 = true;
            })
            .addCase(saveEvent.rejected, (state, { payload }) => {
                state.loading1 = false;
                state.error1 = payload;
                state.success1 = false;
            })
             .addCase(deleteEvent.pending, (state) => {
                state.loading2 = true;
                state.error2 = null;
                state.success2 = false;
                state.delEventInfo=null;
            })
            .addCase(deleteEvent.fulfilled, (state, { payload }) => {
                state.loading2 = false;
                state.delEventInfo = payload;
                state.success2 = true;
            })
            .addCase(deleteEvent.rejected, (state, { payload }) => {
                state.loading2 = false;
                state.error2 = payload;
                state.success2 = false;
            });
    }
});
export default eventSlice.reducer;